// @mui material components

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

import { useQuery } from '@tanstack/react-query';

import { useNavigate, useParams } from 'react-router-dom';

import { Grid } from "@mui/material";
import moment from "moment";
import PropTypes from 'prop-types';
import { useEffect, useState } from "react";

import crowdCountingAPI, { uploadEventData } from "../../api/crowd_counting";
import groupAPI from "../../../../api/groups";

import { ArrowBack } from "@mui/icons-material";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import HeatmapSettings from "modules/crowdcounting/components/Settings";
import MainView from "../../components/MainView";

import { twoDatesRelative } from "helper/formatting";
import { useAuth0 } from "@auth0/auth0-react";

import CameraLocationsGridView from "modules/crowdcounting/components/CameraLocationsGridView";
import SoftInput from "components/SoftInput";
import CrowdCountingEventForm from "modules/crowdcounting/components/CrowdCountingEventForm";



// import ObjModel from "nextus/Models/ObjModel";

function wrapper(content) {
    return (
        <SoftBox p={3}
            sx={({ palette: { white }, boxShadows: { navbarBoxShadow }, borders: { borderRadius }, functions: { rgba, pxToRem } }) => ({
                boxShadow: navbarBoxShadow,
                backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                // backgroundColor: rgba(white.main, 0.8),
                borderRadius: borderRadius.xl,
                height: 'calc(100% - 50px)',
                overflowY: 'auto',
                '::-webkit-scrollbar': {
                    backgroundColor: 'transparent',
                    width: '8px',
                },
                '::-webkit-scrollbar-track': { /* background of the scrollbar except button or resizer */
                    backgroundColor: 'transparent',
                },
                '::-webkit-scrollbar-thumb': { /* scrollbar itself */
                    backgroundColor: '#babac0',
                    borderRadius: '6px',
                    border: `1px solid ${rgba(white.main, 0.8)}`,
                },
                '::-webkit-scrollbar-button': { /* set button(top and bottom of the scrollbar) */
                    display: 'none',
                },
            })}
        >
            {content}
        </SoftBox>
    );
}

function CrowdCountingEventEdit({ map, navTitle, setNavTitle, sidebarState, setSidebarState }) {

    const params = useParams();
    const navigate = useNavigate();
    //place holder data

    const editing_device = typeof params.uuuid != 'undefined';

    const goUpOneLevel = () => {
        let path = '..';
        console.log(navigate)
        navigate(path, { relative: "path" });
    }

    const navigateToDevice = (uuid) => {
        if (typeof params.uuid == 'undefined') {
            let path = './' + uuid;
            navigate(path, { relative: "path" });
        }
    }

    crowdCountingAPI.loadToken(useAuth0());
    groupAPI.loadToken(useAuth0());


    useEffect(() => {
        setSidebarState('sidenav');

    }, [sidebarState]);


    const event = useQuery({
        queryKey: ['getCameraEvents', params.event_id],
        queryFn: async () => {
            return crowdCountingAPI.getCameraEvents(params.event_id)
        }
    });

    let [startLimit, endLimit] = [0, 0]

    const onSubmit = (data, event) => {

        uploadEventData(data);
    };

    if (event.data) {
        startLimit = moment(event.data.event.start_time).unix()
        endLimit = moment(event.data.event.end_time).unix()

        let hasLive = endLimit > moment().unix();
        if (hasLive) {
            endLimit = moment().unix()
        }


        return wrapper(
            <SoftBox sx={{ height: 'calc(100% + 24px)' }}>
                <Grid container spacing={3} mb={2}>
                    <Grid item xs={2} sx={{ transition: 'all 0.7s ease-in-out' }}>
                        <SoftButton onClick={goUpOneLevel}>
                            <SoftTypography><ArrowBack /> {editing_device ? "Edit All Cameras" : "To Event"}</SoftTypography>
                        </SoftButton>
                    </Grid>
                    <Grid item xs={8} sx={{ transition: 'all 0.7s ease-in-out' }} align='center'>
                        <SoftBox >
                            <SoftTypography variant="h2">{event.data.event.name} - {twoDatesRelative(event.data.event.start_time, event.data.event.end_time, Date.now())}</SoftTypography>
                        </SoftBox>
                    </Grid>
                </Grid>
                <CrowdCountingEventForm event={event.data} onSubmit={onSubmit}></CrowdCountingEventForm>

            </SoftBox >
        )
    }
    else {
        return wrapper();
    }
}



CrowdCountingEventEdit.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func,
}

export default CrowdCountingEventEdit;
